var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content",on:{"click":_vm.openMiniapp}},[_vm._v("打开聚爱车小程序")])
}
var staticRenderFns = []

export { render, staticRenderFns }